/* globals npsConfig */

(function ($) {
  var gaLabel = window.location.href;
  var userRate = 0;
  var continueId = null;
  var dataLayer = typeof window.dataLayer === 'undefined' ? '' : window.dataLayer;
  var shareButtons = $('.share-buttons');
  var npsFeedbackTeaser = $('.nps-feedbackModal__teaser');
  var feedbackModal = $('.nps-feedbackModal');

  (function initialize() {
    registerEvents();

    if (shareButtons.length > 0 && shareButtons.css('display') !== 'none') {
      npsFeedbackTeaser.addClass('nps-feedbackModal__teaser--alignToTopOfShareBtns');
    }
  })();

  function registerEvents() {
    $('body').on(
      'click',
      '.nps-feedbackModal__teaser, #wufoo-feedback-box button',
      openNpsFeedbackModal,
    );
    $('.nps-feedbackModal').on('click', '.close', closeNpsFeedbackModal);
    $('.nps-feedbackModal').on('click', '.modal-box__overlay', closeNpsFeedbackModal);
    $('.nps-feedbackModal__singleTab').on('click', userRating);
    $('.modal-box__modal-sections').on('click', '.luna-button', switchStep);
    $('#wufoo-feedback-box').on('click', '.luna-button', switchMessage);
  }

  function switchMessage() {
    $('.wufoo-feedback-start').addClass('is-hidden');
    $('.wufoo-feedback').attr('aria-describedby', 'feedback-end');
    $('.wufoo-feedback-end').removeClass('is-hidden');
  }

  function openNpsFeedbackModal(e) {
    feedbackModal.attr('aria-hidden', false);

    if (!e.currentTarget.dataset && !e.currentTarget.dataset.wufooVote) {
      feedbackModal.data('caller', 'sticky');
    } else {
      feedbackModal.data('caller', 'in context');
    }
  }

  function closeNpsFeedbackModal() {
    feedbackModal.attr('aria-hidden', true);
  }

  function switchStep() {
    var valid = validateNps();
    if (valid.length === 0) {
      showNextStep();
    } else {
      showError(valid);
    }
  }

  function validateNps() {
    var errors = [];
    //step1
    if (
      $('.modal-box__modal-sections--isVisible').hasClass('modal-box__modal-sections--npsStep1')
    ) {
      if ($('.nps-feedbackModal__singleTab--active').length === 0) {
        errors.push('Rating');
      }
    }

    //step2
    if (
      $('.modal-box__modal-sections--isVisible').hasClass('modal-box__modal-sections--npsStep2')
    ) {
      if ($('.nps-feedbackModal .luna-select').val() === 'none') {
        errors.push('Select');
      }

      if ($('.nps-feedbackModal .luna-input--textarea').val() === '') {
        errors.push('Textarea');
      }
    }

    return errors;
  }

  function showError(element) {
    $('.nps-feedbackModal__error').addClass('is-hidden').parent().removeClass('is-invalid');
    $(element).each(function (idx, el) {
      $('.nps-feedbackModal__error' + el)
        .removeClass('is-hidden')
        .parent()
        .addClass('is-invalid');
    });
  }

  function showNextStep() {
    var visibilityClass = 'modal-box__modal-sections--isVisible';
    var currentStep = $('.' + visibilityClass);
    var newStep = currentStep.next();
    var caller = currentStep.parents('.nps-feedbackModal').data('caller');
    currentStep.removeClass(visibilityClass);
    newStep.addClass(visibilityClass);

    if (newStep.hasClass('modal-box__modal-sections--npsStep2')) {
      saveData(null, userRate);
    } else if (newStep.hasClass('modal-box__modal-sections--npsStep3')) {
      trackNpsFormSubmit(caller);
      saveData(continueId);
    }
  }

  /**
   * Track the NPS form submit both via:
   * - global Finder tracking component
   * - ga4 tracking
   *
   * @param caller string
   */
  function trackNpsFormSubmit(caller) {
    const {
      nps_feedback_form: {
        elements: { comment, category },
      },
    } = document.forms;

    if (!comment || !category) {
      return;
    }

    const categoryName = category.options[category.selectedIndex].textContent.trim() || '',
      score = parseInt(userRate, 10),
      customEventParams = {
        source: caller === 'in context' ? 'Was this useful' : 'Sidebar',
        feedback: comment.value || '',
        score,
        categoryName,
      };

    window.finder.tracking.track('npsSubmitted', {
      category: 'nps',
      action: 'submitted',
      label: categoryName,
      value: score,
      ...customEventParams,
    });

    document.dispatchEvent(
      new CustomEvent(`ga4.track`, {
        detail: {
          name: 'npsSubmitted',
          params: customEventParams,
        },
      }),
    );
  }

  function userRating() {
    $('.nps-feedbackModal__singleTab--active').removeClass('nps-feedbackModal__singleTab--active');
    $(this).addClass('nps-feedbackModal__singleTab--active');
    userRate = $(this).text().trim();
  }

  function getDeviceType() {
    if (window.matchMedia('(any-hover:none)').matches) {
      if (window.matchMedia('(max-width: 915px)').matches) {
        return 'mobile';
      }
      return 'tablet';
    }
    return 'desktop';
  }

  function saveData(id, rate) {
    var feedbackTitle = $('.modal-box__modal-sections--npsStep2 .luna-select').val();
    var feedbackContent = $('.modal-box__modal-sections--npsStep2 textarea').val();
    var nicheName = dataLayer[0].category || null;
    var host = window.location.hostname;
    var apiUrl = `https://${getAuUrl(host)}`;
    var deviceType = getDeviceType();

    if (!id) {
      $.ajax({
        type: 'POST',
        url: `${apiUrl}/api/v1.2/?name=tracking`,
        data: {
          data: {
            site: npsConfig.siteUrl,
            url: gaLabel,
            gaid: npsConfig.gaUserId,
            score: rate,
            niche: nicheName,
            device: deviceType,
          },
        },
        success: function (res) {
          continueId = res.continue;
        },
      });
    } else {
      $.ajax({
        type: 'POST',
        url: `${apiUrl}/api/v1.2/?name=tracking&continue=` + id,
        data: {
          data: { feedbackTitle: feedbackTitle, feedback: feedbackContent, device: deviceType },
        },
      });
    }
  }

  /**
   * If the current host URL is a FIN URL, return the corresponding
   * FUS host URL
   *
   * @param {string} currentHostUrl
   * @returns {string}
   */
  function getAuUrl(currentHostUrl) {
    switch (currentHostUrl) {
      case 'www.finder.com':
        return 'www.finder.com.au';
      case 'fus.dev':
        return 'fin.dev';
      case 'site-fus.qa01.au-se1.gcp.finder.com':
        return 'site-fin.qa01.au-se1.gcp.finder.com';
      case 'site-fus.qa02.au-se1.gcp.finder.com':
        return 'site-fin.qa02.au-se1.gcp.finder.com';
      case 'site-fus.qa03.au-se1.gcp.finder.com':
        return 'site-fin.qa03.au-se1.gcp.finder.com';
      case 'site-fus.qa04.au-se1.gcp.finder.com':
        return 'site-fin.qa04.au-se1.gcp.finder.com';
      case 'site-fus.qa05.au-se1.gcp.finder.com':
        return 'site-fin.qa05.au-se1.gcp.finder.com';
      case 'site-fus.qa06.au-se1.gcp.finder.com':
        return 'site-fin.qa06.au-se1.gcp.finder.com';
      case 'fus.staging-01.finder.tools':
        return 'www.staging-06.finder.tools';
      case 'fus.staging-02.finder.tools':
        return 'www.staging-06.finder.tools';
      case 'fus.staging-04.finder.tools':
        return 'www.staging-06.finder.tools';
      case 'fus.staging-05.finder.tools':
        return 'www.staging-06.finder.tools';
      case 'fus.staging-06.finder.tools':
        return 'www.staging-06.finder.tools';
      case 'fus.staging-07.finder.tools':
        return 'www.staging-07.finder.tools';
      default:
        break;
    }

    return currentHostUrl;
  }

  window.addEventListener('showNpsModal', (event) => {
    const modalShown = sessionStorage.getItem('npsModalShown');
    if (modalShown) {
      return;
    }

    var hasRewardsInTable =
      (window.rewardsConfigs && Object.keys(window.rewardsConfigs).length > 0) ||
      document.querySelector('.rewards--element-container') !== null;

    if (hasRewardsInTable) {
      return;
    }

    sessionStorage.setItem('npsModalShown', 'true');
    openNpsFeedbackModal(event);
  });
})(window.jQuery);
